var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddSpeaker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00016 0.333984C10.6822 0.333984 13.6668 3.31865 13.6668 7.00065C13.6668 10.6827 10.6822 13.6673 7.00016 13.6673C3.31816 13.6673 0.333496 10.6827 0.333496 7.00065C0.333496 3.31865 3.31816 0.333984 7.00016 0.333984ZM7.00016 3.66732C6.87934 3.66732 6.7626 3.71108 6.67154 3.7905C6.58048 3.86991 6.52126 3.97962 6.50483 4.09932L6.50016 4.16732V6.50065H4.16683C4.04015 6.50069 3.9182 6.54881 3.82563 6.6353C3.73307 6.72179 3.67678 6.84018 3.66815 6.96657C3.65951 7.09296 3.69917 7.21791 3.77912 7.31618C3.85906 7.41446 3.97333 7.47872 4.09883 7.49598L4.16683 7.50065H6.50016V9.83398C6.5002 9.96067 6.54833 10.0826 6.63481 10.1752C6.7213 10.2677 6.8397 10.324 6.96608 10.3327C7.09247 10.3413 7.21742 10.3016 7.3157 10.2217C7.41397 10.1418 7.47823 10.0275 7.4955 9.90198L7.50016 9.83398V7.50065H9.8335C9.96018 7.50061 10.0821 7.45249 10.1747 7.366C10.2673 7.27952 10.3235 7.16112 10.3322 7.03473C10.3408 6.90834 10.3012 6.78339 10.2212 6.68512C10.1413 6.58685 10.027 6.52259 9.9015 6.50532L9.8335 6.50065H7.50016V4.16732C7.50016 4.03471 7.44748 3.90753 7.35372 3.81376C7.25995 3.72 7.13277 3.66732 7.00016 3.66732Z",
    fill: "#572148"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddSpeaker);
export default __webpack_public_path__ + "static/media/addSpeaker.192b81ceb670b739a1304fff369b25aa.svg";
export { ForwardRef as ReactComponent };